import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
	palette: {
		primary: {
			light: '#C6A984',
			main: '#7F6550',
			dark: '#493422',
			contrastText: '#fff',
		},
		secondary: {
			light: '#F7C6C6',
			main: '#9E4D2B',
			dark: '#F79494',
			contrastText: '#000',
		},
	},
});

export default theme;
